import React from 'react'
import { Route, Switch } from 'react-router'
import ReportSpeditionTransports from './ReportSpeditionTransports'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportSpeditionTransports} />
    </Switch>
)

export default Components
